;
/*!
 * PLA: Photocollants (Meme Maker)
 * Uses http://fabricjs.com
 * Uses https://github.com/PitPik/tinyColorPicker
 */

SubitoTexto.photocollantsMaker = {
	init       : function () {

		var $ = jqPla,
			_this = SubitoTexto.photocollantsMaker;

		_this.$memeMaker = $( '.meme-maker-container' );


		// No use in going any further
		if ( _this.$memeMaker.length < 1 ) {
			return;
		}

		// Safety first : Dependency
		if ( typeof fabric === 'undefined' ) {
			console.error( 'This module requires FabricJs' );
			return;
		}


		// Cache all our selectors and vars
		_this.currMode = 'editing'; // editing, submitting, saved
		_this.$previewPane = _this.$memeMaker.find( '.meme-preview-pane' );
		_this.$textInput = _this.$memeMaker.find( '#meme-text-input' );

		_this.$tabs = _this.$memeMaker.find( '.tab' );
		_this.$tabBtns = _this.$memeMaker.find( '.meme-asset-tab-headers' ).find( 'button' );

		_this.$bgs = _this.$tabs.filter( '.tab-bgs' );
		_this.$stickers = _this.$tabs.filter( '.tab-stickers' );

		_this.fontFamily = 'Oswald';
		_this.fontWeight = 700;

		_this.$textTab = _this.$tabs.filter( '.tab-text' );
		_this.$colourPickersContainer = _this.$textTab.find( '.colour-pickers' );
		_this.$colourPickers = _this.$colourPickersContainer.find( '.colour-picker-text-toggle' );
		_this.$colourPickerFill = _this.$colourPickers.filter( '.colour-picker-text-inner' );
		_this.$colourPickerFillInput = _this.$textTab.find( '[name="colour-picker-text-inner"]' );
		_this.textFillDefaultColour = '#04b7db'; // For resetting
		_this.textFillColour = '#04b7db';
		_this.$colourPickerStroke = _this.$colourPickers.filter( '.colour-picker-text-outer' );
		_this.$colourPickerStrokeInput = _this.$textTab.find( '[name="colour-picker-text-outer"]' );
		_this.textStrokeDefaultColour = '#fff'; // For resetting
		_this.textStrokeColour = '#fff';


		_this.canvasGrowthRatio = 2;
		_this.canvasWidth = 575;
		_this.canvasHeight = 312;


		// partial reference: http://fabricjs.com/customization
		_this.fabricJsBorderColor = 'blue';
		_this.fabricJsCornerColor = 'green';
		_this.fabricJsCornerSize = 15 * _this.canvasGrowthRatio;
		_this.fabricJsTransparentCorners = false;
		_this.fabricJsBorderScaleFactor = 0.5 / _this.canvasGrowthRatio; //  ( 1 / borderScaleFactor ) = width of "selection border"


		_this.$saveBtn = _this.$memeMaker.find( '.meme-btn-save' );
		_this.$submitBtn = _this.$memeMaker.find( '.meme-btn-submit' );
		_this.$resetBtn = _this.$memeMaker.find( '.meme-btn-reset' );


		_this.$photoForm = _this.$memeMaker.find( '#photocollant-form' );

		_this.$inputImageData = _this.$memeMaker.find( '.meme-result-input' );
		_this.$inputBgUsed = _this.$memeMaker.find( '.meme-bg-input' );
		_this.$inputStickersUsed = _this.$memeMaker.find( '.meme-stickers-input' );

		_this.$inputName = _this.$memeMaker.find( '#name' );
		_this.$inputCity = _this.$memeMaker.find( '#city' );
		_this.$inputAge = _this.$memeMaker.find( '#age' );

		_this.$messageSuccess = _this.$memeMaker.find( '.message-success' );

		_this.$btnCancel = _this.$memeMaker.find( '.btn-annuler' );

		_this.$btnSaveYes = _this.$memeMaker.find( '.btn-save-photocollant-yes' );
		_this.$btnSaveNo = _this.$memeMaker.find( '.btn-save-photocollant-no' );


		_this.selectedImageId = 0;
		_this.selectedStickerIds = [];
		_this.selectedText = '';


		// Let's roll!

		new Fingerprint2( {
			excludeAvailableScreenResolution: true,
			excludeScreenResolution         : true
		} ).get( function ( result, components ) {
			_this.fingerprint = result;
		} );


		_this.addTabLabels();

		_this.setupFabric();
		_this.addDeleteButton();

		_this.addColourPickerVisualizer();

		_this.bindEvents();
		_this.setupColourPicker();


	},
	setupFabric: function () {
		var $ = jqPla,
			_this = SubitoTexto.photocollantsMaker;


		_this.$canvas = $( '<canvas class="meme-canvas" />' ).appendTo( _this.$previewPane );

		var currHeight = _this.$previewPane.outerHeight(),
			currWidth = _this.$previewPane.width();

		_this.$canvas
			.width( currHeight )
			.height( currWidth );


		_this.fabricCtx = _this.$canvas[ 0 ].getContext( '2d' );

		_this.fabricCanvas = new fabric.Canvas( _this.$canvas[ 0 ], {
			allowTouchScrolling: false,
			selection          : false
		} );

		_this.$previewPane.find( '.canvas-container' ).css( {
			position: 'absolute'
		} );

		_this.fabricCanvas.setDimensions( {
			width : 1280, //currWidth * _this.canvasGrowthRatio,
			height: 695, //currHeight * _this.canvasGrowthRatio
		} );

		//_this.fabricCanvas.setZoom(  _this.canvasGrowthRatio);


		// Show trash
		_this.fabricCanvas.on( 'object:selected', function ( e ) {

			// Only showing for Stickers (not Text)
			var activeObject = _this.fabricCanvas.getActiveObject();
			if ( activeObject && typeof activeObject.type != 'undefined' && activeObject.type != 'text' ) {
				_this.$btnDeleteObject.addClass( 'visible' );
			} else {
				_this.$btnDeleteObject.removeClass( 'visible' );
			}

		} );

		// HIde the trash
		_this.fabricCanvas.on( 'selection:cleared', function ( e ) {
			_this.$btnDeleteObject.removeClass( 'visible' );
		} );


		// Make sure the text fits within the container
		_this.fabricCanvas.on( 'object:modified', function ( e ) {
			var obj = e.target,
				activeObject = _this.fabricCanvas.getActiveObject();

			if ( !activeObject || typeof activeObject.type == 'undefined' ) {
				return;
			}


			var obj = e.target;
			var canvas = obj.canvas;
			var top = obj.top;
			var left = obj.left;
			var zoom = canvas.getZoom();
			var pan_x = canvas.viewportTransform[ 4 ];
			var pan_y = canvas.viewportTransform[ 5 ];

			// width & height we are constraining to must be calculated by applying the inverse of the current viewportTransform
			var c_width = canvas.width / zoom;
			var c_height = canvas.height / zoom;


			var w = obj.width * obj.scaleX
			var left_adjust, right_adjust
			if ( obj.originX == "center" ) {
				left_adjust = right_adjust = w / 2;
			} else {
				left_adjust = 0;
				right_adjust = w;
			}

			var h = obj.height * obj.scaleY;
			var top_adjust, bottom_adjust;
			if ( obj.originY == "center" ) {
				top_adjust = bottom_adjust = h / 2;
			} else {
				top_adjust = 0;
				bottom_adjust = h;
			}

			// if you need margins set them here
			var top_margin = 0;
			var bottom_margin = 0;
			var left_margin = 0;
			var right_margin = 0;


			var top_bound = top_margin + top_adjust - pan_y;
			var bottom_bound = c_height - bottom_adjust - bottom_margin - pan_y;
			var left_bound = left_margin + left_adjust - pan_x;
			var right_bound = c_width - right_adjust - right_margin - pan_x;

			if ( w > c_width ) {
				obj.setLeft( left_bound );
			} else {
				obj.setLeft( Math.min( Math.max( left, left_bound ), right_bound ) );
			}

			if ( h > c_height ) {
				obj.setTop( top_bound );
			} else {
				obj.setTop( Math.min( Math.max( top, top_bound ), bottom_bound ) );
			}
		} );

	},


	resizeCanvas: function () {
		var $ = jqPla,
			_this = SubitoTexto.photocollantsMaker;


	},

	deleteActiveFabricElement: function () {
		var $ = jqPla,
			_this = SubitoTexto.photocollantsMaker;

		var activeObject = _this.fabricCanvas.getActiveObject();

		if ( activeObject && typeof activeObject.type != 'undefined' && activeObject.type != 'text' ) {
			_this.fabricCanvas.remove( activeObject );

			// Remove it from our collection / input as well
			if ( typeof activeObject.stickerId != 'undefined' ) {
				var imgId = activeObject.stickerId,
					firstFoundIndex = _this.selectedStickerIds.indexOf( imgId );

				_this.selectedStickerIds.splice( firstFoundIndex, 1 );
				_this.$inputStickersUsed.val( _this.selectedStickerIds.join( ',' ) );
			}
		}

		//console.log( '_this.selectedStickerIds', _this.selectedStickerIds );
	},


	//    ______               _
	//   |  ____|             | |
	//   | |____   _____ _ __ | |_ ___
	//   |  __\ \ / / _ \ '_ \| __/ __|
	//   | |___\ V /  __/ | | | |_\__ \
	//   |______\_/ \___|_| |_|\__|___/
	//
	//
	bindEvents: function () {
		var $ = jqPla,
			_this = SubitoTexto.photocollantsMaker;


		_this.$textInput.on( 'keyup.photocollantsText',
			PLA.UTILS.debounce( function () {
				_this.handleTextChange();
			}, 150 )
		);


		_this.$tabBtns.on( 'click.photocollantsTabs', function ( e ) {

			var $this = $( this ),
				isActive = $this.hasClass( 'active' );

			// No use in re-activating something that's already active
			if ( !isActive ) {
				_this.switchTabs( $this );
			}

		} );

		// Fabric: Change the BG
		_this.$bgs.on( 'click.photocollantBgs', '.meme-bg-btn', function ( e ) {
			_this.selectBg( $( this ) );
		} );

		// Fabric: Add stickers
		_this.$stickers.on( 'click.photocollantStickers', 'img', function ( e ) {
			_this.addSticker( $( this ) );
		} );


		_this.$submitBtn.on( 'click.photocollantFormShow', function ( e ) {

			if ( _this.$memeMaker.hasClass( 'form-entry' ) ) {
				_this.$memeMaker
					.removeClass( 'form-entry' );

				_this.$submitBtn.removeClass( 'active' );

				_this.$photoForm.find( 'input, textare' ).attr( 'tabindex', -1 );
				_this.$photoForm.attr( 'aria-hidden', 'true' );

			} else {
				_this.currMode = 'formEntry';

				_this.$memeMaker
					.removeClass( 'saving editing submitting saved' )
					.addClass( 'form-entry' );

				_this.$submitBtn.addClass( 'active' );

				_this.$photoForm.find( 'input, textare' ).attr( 'tabindex', 0 );

				_this.$photoForm.attr( 'aria-hidden', 'false' );

				if ( $( window ).width() < 1200 ) {
					PLA.UTILS.scrollTop.scrollTo( _this.$submitBtn, -40 );
				}
			}


		} );


		// Save to phone/desktop
		_this.$saveBtn.on( 'click.photocollantSave', function ( e ) {
			_this.renderImage();
		} );


		_this.$photoForm.on( 'submit', function ( e ) {
			e.preventDefault();

			if ( _this.currMode != 'submitting' ) {
				_this.renderImage();
				_this.compileAssets;
			}

			if ( _this.currMode != 'saved' ) {
				_this.saveToServer();
			}
		} );

		_this.$photoForm.on( 'reset', function ( e ) {
			_this.$memeMaker
				.removeClass( 'submitting form-entry' )

		} );


		_this.$btnDeleteObject.on( 'click', function ( e ) {
			_this.deleteActiveFabricElement();
		} );


		_this.$resetBtn.on( 'click', function ( e ) {
			_this.resetEverything();
		} );


		// var debounceResizeCanvas = PLA.UTILS.debounce( function () {
		// 	_this.resizeCanvas();
		// }, 250 );
		//
		// window.addEventListener( 'resize', debounceResizeCanvas );


		_this.$btnSaveYes.on( 'click', function ( e ) {

			// IE Edge fix based on http://stackoverflow.com/a/24354303
			if ( window.navigator.msSaveOrOpenBlob ) {
				var blobObject = _this.dataURItoBlob( _this.$inputImageData.val() );
				window.navigator.msSaveOrOpenBlob( blobObject, 'subito.png' );
			} else {
				$( this ).attr( "download", "download" );
				$( this )[ 0 ].download = 'subito.png';
				$( this )[ 0 ].href = URL.createObjectURL( _this.dataURItoBlob( _this.$inputImageData.val() ) );
			}


			setTimeout( function () {
				_this.resetEverything();
			}, 500 );
		} );


		_this.$btnSaveNo.on( 'click', function ( e ) {
			_this.resetEverything();
		} );

	},


	deactivateEditing: function () {
		var $ = jqPla,
			_this = SubitoTexto.photocollantsMaker;

		_this.$textInput.off( 'keyup.photocollantsText' );
		_this.$tabBtns.off( 'click.photocollantsTabs' );
		_this.$bgs.off( 'click.photocollantBgs' );
		_this.$stickers.off( 'click.photocollantStickers' );
		_this.$saveBtn.off( 'click.photocollantSave' );

	},

	resetEverything: function () {
		var $ = jqPla,
			_this = SubitoTexto.photocollantsMaker;

		_this.fabricCanvas.clear();

		_this.$memeMaker
			.removeClass( 'form-entry saving editing submitting saved' );

		// BG images
		_this.fabricCanvas.setBackgroundImage( null, _this.fabricCanvas.renderAll.bind( _this.fabricCanvas ) );
		_this.selectedImageId = '';
		_this.$inputBgUsed.val( '' );


		_this.textFillColour = _this.textFillDefaultColour;
		_this.$colourPickerFill.css( {
			background: _this.textFillDefaultColour
		} );
		_this.$colourPickerFillInput.val( _this.textFillDefaultColour )
		_this.$svgColourPickerVisualizer.find( '.letter-fill' ).attr( 'fill', _this.textFillDefaultColour );

		_this.textStrokeColour = _this.textStrokeDefaultColour;
		_this.$colourPickerStroke.css( {
			background: _this.textStrokeDefaultColour
		} );
		_this.$colourPickerStrokeInput.val( _this.textStrokeDefaultColour );
		_this.$svgColourPickerVisualizer.find( '.letter-stroke' ).attr( 'fill', _this.textStrokeDefaultColour );


		// Stickers
		_this.selectedStickerIds = [];
		_this.$inputStickersUsed.val( '' );


		_this.$messageSuccess.hide().attr( 'aria-hidden', 'true' );
		_this.$memeMaker.removeClass( 'form-entry' );
		_this.$submitBtn.removeClass( 'active' );

		// Text
		_this.$textInput.val( '' );
		_this.selectedText = '';
		if ( _this.canvasText != 'undefined' ) {
			_this.canvasText.setText( '' );
		}
	},


	addDeleteButton: function () {
		var $ = jqPla,
			_this = SubitoTexto.photocollantsMaker;
		_this.$btnDeleteObject = $( '<button type="button" class="meme-delete-btn"><img src="/_/images/icon-trash-2.svg" /></button>' ).appendTo( _this.$previewPane );
	},

	//    _______    _
	//   |__   __|  | |
	//      | | __ _| |__  ___
	//      | |/ _` | '_ \/ __|
	//      | | (_| | |_) \__ \
	//      |_|\__,_|_.__/|___/
	//
	//
	switchTabs: function ( $clicked ) {
		var $ = jqPla,
			_this = SubitoTexto.photocollantsMaker;

		var desiredTab = $clicked.data( 'tab-related' ),
			$desiredTab = _this.$tabs.filter( '.' + desiredTab );

		_this.$tabs.not( $desiredTab ).add( _this.$tabBtns.not( $clicked ) ).removeClass( 'active' );

		$desiredTab.add( $clicked ).addClass( 'active' );
	},

	addTabLabels: function () {

		var $ = jqPla,
			_this = SubitoTexto.photocollantsMaker;

		_this.$tabBtns.filter( '.tab-header-bg' ).html( _this.svgMemeImage );
		_this.$tabBtns.filter( '.tab-header-text' ).html( _this.svgMemeText );
		_this.$tabBtns.filter( '.tab-header-sticker' ).html( _this.svgMoustache );

	},


	//     _____      _                    _____ _      _
	//    / ____|    | |                  |  __ (_)    | |
	//   | |     ___ | | ___  _   _ _ __  | |__) |  ___| | _____ _ __
	//   | |    / _ \| |/ _ \| | | | '__| |  ___/ |/ __| |/ / _ \ '__|
	//   | |___| (_) | | (_) | |_| | |    | |   | | (__|   <  __/ |
	//    \_____\___/|_|\___/ \__,_|_|    |_|   |_|\___|_|\_\___|_|
	//
	//
	addColourPickerVisualizer: function () {
		var $ = jqPla,
			_this = SubitoTexto.photocollantsMaker;

		_this.$svgColourPickerVisualizer = $( '<div class="colour-picker-visualizer-container">' + _this.svgColourPickerVisualizer() + '</div>' ).prependTo( _this.$colourPickersContainer );
	},

	setupColourPicker: function () {
		var $ = jqPla,
			_this = SubitoTexto.photocollantsMaker;

		_this.$colourPickerFill.css( {
			background: _this.textFillColour
		} );

		_this.$colourPickerStroke.css( {
			background: _this.textStrokeColour
		} );


		_this.$colourPickers.colorPicker( {
			//doRender: 'div div',

			renderCallback: function ( $elm, toggled ) {
				var chosenColor = this.color.colors.HEX,
					isInnerColour = $elm.hasClass( 'colour-picker-text-inner' );

				if ( isInnerColour ) {
					_this.$colourPickerFillInput.val( '#' + chosenColor );
					_this.$svgColourPickerVisualizer.find( '.letter-fill' ).attr( 'fill', '#' + chosenColor );
					_this.textFillColour = '#' + chosenColor;
				} else {
					_this.$colourPickerStrokeInput.val( '#' + chosenColor );
					_this.$svgColourPickerVisualizer.find( '.letter-stroke' ).attr( 'fill', '#' + chosenColor );
					_this.textStrokeColour = '#' + chosenColor;
				}


				_this.handleTextChange();

			}
		} );

	},

	svgColourPickerVisualizer: function () {
		var $ = jqPla,
			_this = SubitoTexto.photocollantsMaker;

		return '<svg class="colour-picker-visual" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 100">' +
			'<defs>' +
			'<style>' +
			'.colour-picker-visual .cls-1{fill:' + _this.textFillColour + ';}' +
			'.colour-picker-visual .cls-2{fill:none;stroke:' + _this.textStrokeColour + ';stroke-miterlimit:10;stroke-width:2px;}' +

			'</style>' +
			'</defs>' +
			'<title>colour-picker-visual</title>' +
			'<path class="letter-fill" fill="' + _this.textFillColour + '" d="M181.95,78.77H151.81l-4.19,14.18h-27.1l32.29-85.9h29L214,92.95h-27.8ZM176.44,60.2,167,29.32,157.58,60.2Z"/>' +
			'<path class="letter-stroke" fill="' + _this.textStrokeColour + '" d="M218.37,95.95H184l-4.3-14.18H154.05l-4.19,14.18H116.19l34.54-91.9h33.11Zm-29.9-6h21.24l-30-79.9h-24.8l-30,79.9h20.53l4.19-14.18h34.6Zm-8-26.75h-27L166.94,19Zm-18.88-6h10.76L167,39.59Z"/>' +
			'<circle class="stroke-circle cls-2" cx="136.65" cy="34.99" r="16.3"/>' +
			'<polyline class="stroke-line cls-2" points="120.35 34.99 30.91 34.99 30.91 51.29"/>' +
			'<polyline class="fill-line cls-2" points="195.32 78.01 269.09 78.01 269.09 49.01"/>' +
			'</svg>'
	},


	svgMoustache: '<svg id="meme-maker-moustache"  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 160.9 110.05"><path class="moustache" d="M111.46,0A15.44,15.44,0,1,0,126.9,15.43,15.43,15.43,0,0,0,111.46,0ZM47.19,0A15.44,15.44,0,1,0,62.63,15.43,15.43,15.43,0,0,0,47.19,0Zm95.63,83.33C131.3,80.61,118.18,64,105.94,62.18c-15.53-1.71-22.86,5.06-25.48,11.64C77.84,67.25,70.5,60.46,55,62.18,42.74,64,29.61,80.61,18.09,83.33S0,75.81,0,75.81s9.29,34.4,43.05,34.24c25.45-.12,34.54-13.6,37.41-22.63,2.86,9,11.94,22.51,37.39,22.63,33.76.16,43.05-34.24,43.05-34.24S154.34,86,142.82,83.33Zm0,0"/></svg>',

	svgMemeText: '<svg id="meme-maker-text" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21.56 13.63"><path class="text-icon" d="M8.6,10.82a24.25,24.25,0,0,0,.14,2.63H6.4a8.57,8.57,0,0,1-.16-1.24A3,3,0,0,1,3.4,13.63c-2.51,0-3.4-1.57-3.4-3.1C0,8.7,1.26,7.19,4.79,7.19H6V6.44C6,5.62,5.73,5,4.54,5A1.36,1.36,0,0,0,3,6.32H.39c.1-1.61,1.06-3.24,4.18-3.24,2.4,0,4,.84,4,3.36ZM6.07,8.9H4.83c-1.83,0-2.16.75-2.16,1.41a1.25,1.25,0,0,0,1.43,1.3c1.59,0,2-1.06,2-2.49Z"/><path d="M13.21,10.25l-.94,3.2H9.58C9.76,12.92,13.49.59,13.69,0h3.55l4.32,13.45H18.69l-1-3.2ZM17.12,8c-.83-2.73-1.41-4.65-1.73-5.91h0c-.31,1.49-.92,3.59-1.63,5.91Z"/></svg>',

	svgMemeImage: '<svg id="meme-maker-image" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 252.46 199.13"><path class="image" d="M248.46,0H4A4,4,0,0,0,0,4V195.13a4,4,0,0,0,4,4H248.46a4,4,0,0,0,4-4V4a4,4,0,0,0-4-4Zm-20,167.24-55-57a1.64,1.64,0,0,0-2.26-.09L133,143.77,84.27,83.71a1.63,1.63,0,0,0-2.58.05L24,161.17V24H228.46Zm0,0"/><path d="M168,81.78a19.62,19.62,0,1,0-19.62-19.62A19.63,19.63,0,0,0,168,81.78Zm0,0"/></svg>',


	//    _______        _     ______ _      _     _
	//   |__   __|      | |   |  ____(_)    | |   | |
	//      | | _____  _| |_  | |__   _  ___| | __| |
	//      | |/ _ \ \/ / __| |  __| | |/ _ \ |/ _` |
	//      | |  __/>  <| |_  | |    | |  __/ | (_| |
	//      |_|\___/_/\_\\__| |_|    |_|\___|_|\__,_|
	//
	//
	handleTextChange: function () {
		var $ = jqPla,
			_this = SubitoTexto.photocollantsMaker;


		var currText = _this.$textInput.val();

		// console.log( 'Text changed', currText );

		if ( typeof _this.canvasText === 'undefined' ) {
			_this.canvasText = new fabric.Text( currText, {
				fontFamily     : _this.fontFamily,
				fontWeight     : _this.fontWeight,
				lockUniScaling : true,
				editable       : false,
				fill           : _this.textFillColour,
				stroke         : _this.textStrokeColour,
				_fontSizeMult  : 0.9,
				strokeWidth    : 2 * _this.canvasGrowthRatio,
				centeredScaling: true,
				fontSize       : 160,
				textAlign      : 'center',
				originX        : 'center',
				originY        : 'center',
			} );


			_this.fabricCanvas.add( _this.canvasText );

			_this.canvasText.center();

			_this.canvasText.set( {
				borderColor       : _this.fabricJsBorderColor,
				cornerColor       : _this.fabricJsCornerColor,
				cornerSize        : _this.fabricJsCornerSize,
				transparentCorners: _this.fabricJsTransparentCorners,
				borderScaleFactor : _this.fabricJsBorderScaleFactor
			} );

			//http://fabricjs.com/docs/fabric.Object.html#setControlsVisibility
			_this.canvasText.setControlsVisibility( {
				mt: false, // middle top disable
				mb: false, // midle bottom
				ml: false, // middle left
				mr: false, // I think you get it
			} );

		} else {
			// console.log( 'Setting text' );

			_this.canvasText.stroke = _this.textStrokeColour;
			_this.canvasText.fill = _this.textFillColour;
			_this.canvasText.setText( currText );

			_this.canvasText.center();

			var maxWidth = Math.floor( _this.fabricCanvas.width - (_this.fabricCanvas.width * 0.05) );

			if ( _this.canvasText.width > maxWidth ) {
				var wrappedText = _this.wrapCanvasText( _this.canvasText, _this.$canvas[ 0 ], maxWidth, _this.fabricCanvas.height, _this.canvasText.textAlign );

				_this.canvasText.setText( wrappedText );

				_this.canvasText.center();
			}

			//console.log( '_this.canvasText.width', _this.canvasText.width, _this.fabricCanvas.width );

		}

		_this.canvasText.bringToFront();
		_this.fabricCanvas.renderAll();


		_this.selectedText = currText;


	},


	//    ____   _____   _____
	//   |  _ \ / ____| |_   _|
	//   | |_) | |  __    | |  _ __ ___   __ _  __ _  ___
	//   |  _ <| | |_ |   | | | '_ ` _ \ / _` |/ _` |/ _ \
	//   | |_) | |__| |  _| |_| | | | | | (_| | (_| |  __/
	//   |____/ \_____| |_____|_| |_| |_|\__,_|\__, |\___|
	//                                          __/ |
	//                                         |___/
	selectBg: function ( $clicked ) {
		var $ = jqPla,
			_this = SubitoTexto.photocollantsMaker;


		var $img = $clicked.find( 'img' ),
			imgPath = $img.attr( 'src' );

		//console.log( 'Changed BG', $clicked, imgPath );

		if ( typeof _this.fabricCurrentImage != 'undefined' ) {
			_this.fabricCurrentImage.remove();
		}

		_this.fabricCanvas.setBackgroundImage( imgPath, _this.fabricCanvas.renderAll.bind( _this.fabricCanvas ), {
			width  : _this.fabricCanvas.width,
			height : _this.fabricCanvas.height,
			// Needed to position backgroundImage at 0/0
			originX: 'left',
			originY: 'top'
		} );


		_this.selectedImageId = parseInt( $clicked.data( 'bg-id' ) );
		_this.$inputBgUsed.val( _this.selectedImageId );


	},


	//     _____ _   _      _
	//    / ____| | (_)    | |
	//   | (___ | |_ _  ___| | _____ _ __ ___
	//    \___ \| __| |/ __| |/ / _ \ '__/ __|
	//    ____) | |_| | (__|   <  __/ |  \__ \
	//   |_____/ \__|_|\___|_|\_\___|_|  |___/
	//
	//
	addSticker: function ( $clicked ) {
		var $ = jqPla,
			_this = SubitoTexto.photocollantsMaker;

		var imgPath = $clicked.attr( 'src' ),
			imgId = $clicked.data( 'sticker-id' );

		//console.log( 'Sticker', $clicked, imgPath );

		var addedSticker = fabric.loadSVGFromURL( imgPath, function ( objects, options ) {
			var svgImg = fabric.util.groupSVGElements( objects, options );

			_this.fabricCanvas.add( svgImg );


			if ( typeof  _this.canvasText != 'undefined' ) {
				_this.canvasText.bringToFront();
			}


			_this.fabricCanvas.calcOffset();
			svgImg.scaleToWidth( _this.$previewPane.width() * 0.5 );
			_this.fabricCanvas.centerObject( svgImg );

			_this.fabricCanvas.renderAll();

			_this.selectedStickerIds.push( imgId );
			_this.$inputStickersUsed.val( _this.selectedStickerIds.join( ',' ) );

			svgImg.set( {
				borderColor       : _this.fabricJsBorderColor,
				cornerColor       : _this.fabricJsCornerColor,
				cornerSize        : _this.fabricJsCornerSize,
				transparentCorners: _this.fabricJsTransparentCorners,
				borderScaleFactor : _this.fabricJsBorderScaleFactor,

				stickerId: imgId
			} );


			//http://fabricjs.com/docs/fabric.Object.html#setControlsVisibility
			svgImg.setControlsVisibility( {
				mt: false, // middle top disable
				mb: false, // midle bottom
				ml: false, // middle left
				mr: false, // I think you get it
			} );


			_this.fabricCanvas.setActiveObject( svgImg );
			svgImg.setCoords();
			_this.fabricCanvas.renderAll();

		} );


	},


	//     _____                      _ _
	//    / ____|                    (_) |
	//   | |     ___  _ __ ___  _ __  _| | ___
	//   | |    / _ \| '_ ` _ \| '_ \| | |/ _ \
	//   | |___| (_) | | | | | | |_) | | |  __/
	//    \_____\___/|_| |_| |_| .__/|_|_|\___|
	//                         | |
	//                         |_|
	compileAssets: function () {
		var $ = jqPla,
			_this = SubitoTexto.photocollantsMaker;

		_this.$inputBgUsed.val( _this.selectedImageId );
		_this.$inputStickersUsed.val( _this.selectedStickerIds.join( ',' ) );
	},
	renderImage  : function () {
		var _this = SubitoTexto.photocollantsMaker;


		_this.fabricCanvas.deactivateAll().renderAll();

		// We had problems with fabricJS making Retina devices save in suuuuper big resolutions
		var sizeMultiplier = 1;
		if ( typeof window.devicePixelRatio != 'undefined' && window.devicePixelRatio > 1 ) {
			sizeMultiplier = 1 / window.devicePixelRatio;
		}


		var imageData = _this.fabricCanvas.toDataURL( {
			format    : 'png',
			multiplier: sizeMultiplier
		} );

		_this.$inputImageData.val( imageData );
	},


	//     _____
	//    / ____|
	//   | (___   __ ___   _____
	//    \___ \ / _` \ \ / / _ \
	//    ____) | (_| |\ V /  __/
	//   |_____/ \__,_| \_/ \___|
	//
	//
	saveToServer            : function () {
		var $ = jqPla,
			_this = SubitoTexto.photocollantsMaker;

		if ( typeof CONFIG == 'undefined' || typeof CONFIG.photocollants_submit_url == 'undefined' ) {
			console.error( 'I don\'t know where to save' );
			return;
		}


		_this.showWaitSpinner();

		_this.compileAssets();
		_this.renderImage();


		var formData = new FormData();

		formData.append( 'stickersIds', _this.selectedStickerIds.join( ',' ) );
		formData.append( 'bgId', _this.selectedImageId );
		formData.append( 'memeText', _this.selectedText.replace( /\r?\n|\r/g, '' ) ); // removing any line-brekas
		formData.append( 'submitterName', _this.$inputName.val() );
		formData.append( 'submitterCity', _this.$inputCity.val() );
		formData.append( 'submitterAge', _this.$inputAge.val() );
		formData.append( 'fingerprint', _this.fingerprint );


		var blobImage = _this.dataURItoBlob( _this.$inputImageData.val() );
		formData.append( 'imageData', blobImage );


		$.ajax( {
			url        : CONFIG.photocollants_submit_url,
			type       : 'POST',
			xhr        : function () {  // Custom XMLHttpRequest
				var myXhr = $.ajaxSettings.xhr();
				if ( myXhr.upload ) { // Check if upload property exists
					myXhr.upload.addEventListener( 'progress', function ( e ) {
						//	_this.progressHandlingFunction( e, $progress )
					}, false ); // For handling the progress of the upload
				}
				return myXhr;
			},
			//Ajax events
			//  beforeSend: beforeSendHandler,
			success    : function ( _data ) {
				if ( typeof _data.success != 'undefined' && _data.success == 1 ) {
					_this.currMode = 'saved';
					_this.$memeMaker
						.removeClass( 'saving editing submitting form-entry' )
						.addClass( 'saved' );

					SubitoTexto.form.processForm( _this.$photoForm, _data.errors, true );

					_this.$messageSuccess.find( '.inner' ).slideDown( function () {
						setTimeout( function () {
							PLA.UTILS.scrollTop.scrollTo( _this.$messageSuccess, -40 );
						}, 500 );
						_this.$messageSuccess.focus();
					} );

				} else if ( typeof _data.success != 'undefined' && typeof _data.errors != 'undefined' ) {
					SubitoTexto.form.processForm( _this.$photoForm, _data.errors, true );

					if ( $( window ).width() < 1200 ) {
						PLA.UTILS.scrollTop.scrollTo( $( '.meme-form-container' ), -40 );
					}
				}

				_this.hideWaitSpinner();
			},
			error      : function ( xhr, ajaxOptions, thrownError ) {
				console.log( xhr, ajaxOptions, thrownError );

				alert( xhr.response );
				_this.hideWaitSpinner();
			},
			// Form data
			data       : formData,
			//Options to tell jQuery not to process data or worry about content-type.
			cache      : false,
			contentType: false,
			processData: false
		} );
	},
	progressHandlingFunction: function ( e, $progress ) {
		if ( e.lengthComputable ) {
			$progress.attr( { value: e.loaded, max: e.total } ).show();
		}
	},


	showWaitSpinner: function () {
		var $ = jqPla,
			_this = SubitoTexto.photocollantsMaker;

		_this.$spinner = $( '<div class="ajax-spinner-container"><div class="ajax-spinner"></div></div>' ).appendTo( 'body' );
	},

	hideWaitSpinner: function () {
		var $ = jqPla,
			_this = SubitoTexto.photocollantsMaker;

		if ( typeof _this.$spinner != 'undefined' && _this.$spinner.length > 0 ) {
			_this.$spinner.remove();
			delete _this.$spinner;
		}
	},

	dataURItoBlob: function ( dataURI ) {
		// convert base64/URLEncoded data component to raw binary data held in a string
		var byteString;
		if ( dataURI.split( ',' )[ 0 ].indexOf( 'base64' ) >= 0 )
			byteString = atob( dataURI.split( ',' )[ 1 ] );
		else
			byteString = unescape( dataURI.split( ',' )[ 1 ] );

		// separate out the mime component
		var mimeString = dataURI.split( ',' )[ 0 ].split( ':' )[ 1 ].split( ';' )[ 0 ];

		// write the bytes of the string to a typed array
		var ia = new Uint8Array( byteString.length );
		for ( var i = 0; i < byteString.length; i++ ) {
			ia[ i ] = byteString.charCodeAt( i );
		}

		return new Blob( [ ia ], { type: mimeString } );
	},

	wrapCanvasText: function ( t, canvas, maxW, maxH, justify ) {

		if ( typeof maxH === "undefined" ) {
			maxH = 0;
		}
		var words = t.text.split( " " );
		var formatted = '';

		// This works only with monospace fonts
		justify = justify || 'left';

		// clear newlines
		var sansBreaks = t.text.replace( /(\r\n|\n|\r)/gm, "" );
		// calc line height
		var lineHeight = new fabric.Text( sansBreaks, {
			fontFamily: t.fontFamily,
			fontSize  : t.fontSize
		} ).height;

		// adjust for vertical offset
		var maxHAdjusted = maxH > 0 ? maxH - lineHeight : 0;
		var context = canvas.getContext( "2d" );


		context.font = t.fontSize + "px " + t.fontFamily;
		var currentLine = '';
		var breakLineCount = 0;

		n = 0;
		while ( n < words.length ) {
			var isNewLine = currentLine == "";
			var testOverlap = currentLine + ' ' + words[ n ];

			// are we over width?
			var w = context.measureText( testOverlap ).width;

			if ( w < maxW ) { // if not, keep adding words
				if ( currentLine != '' ) currentLine += ' ';
				currentLine += words[ n ];
				// formatted += words[n] + ' ';
			} else {

				// if this hits, we got a word that need to be hypenated
				if ( isNewLine ) {
					var wordOverlap = "";

					// test word length until its over maxW
					for ( var i = 0; i < words[ n ].length; ++i ) {

						wordOverlap += words[ n ].charAt( i );
						var withHypeh = wordOverlap + "-";

						if ( context.measureText( withHypeh ).width >= maxW ) {
							// add hyphen when splitting a word
							withHypeh = wordOverlap.substr( 0, wordOverlap.length - 2 ) + "-";
							// update current word with remainder
							words[ n ] = words[ n ].substr( wordOverlap.length - 1, words[ n ].length );
							formatted += withHypeh; // add hypenated word
							break;
						}
					}
				}
				while ( justify == 'right' && context.measureText( ' ' + currentLine ).width < maxW )
					currentLine = ' ' + currentLine;

				while ( justify == 'center' && context.measureText( ' ' + currentLine + ' ' ).width < maxW )
					currentLine = ' ' + currentLine + ' ';

				formatted += currentLine + '\n';
				breakLineCount++;
				currentLine = "";

				continue; // restart cycle
			}
			if ( maxHAdjusted > 0 && (breakLineCount * lineHeight) > maxHAdjusted ) {
				// add ... at the end indicating text was cutoff
				formatted = formatted.substr( 0, formatted.length - 3 ) + "...\n";
				currentLine = "";
				break;
			}
			n++;
		}

		if ( currentLine != '' ) {
			while ( justify == 'right' && context.measureText( ' ' + currentLine ).width < maxW )
				currentLine = ' ' + currentLine;

			while ( justify == 'center' && context.measureText( ' ' + currentLine + ' ' ).width < maxW )
				currentLine = ' ' + currentLine + ' ';

			formatted += currentLine + '\n';
			breakLineCount++;
			currentLine = "";
		}

		// get rid of empy newline at the end
		formatted = formatted.substr( 0, formatted.length - 1 );

		return formatted;
	}

}
;